import { API_URL } from "../../shared/constants";
import { emptySplitApi } from "../emptySplit-api";

export const feedbackApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    feedbackList: builder.query<any, any>({
      query: (data: any) => {
        return {
          url: `/${API_URL.REPORTS}/customer-feedback`,
          method: "post",
          body: data,
        };
      },
    }),
    feedbackGet: builder.query({
      query: (id) => ({
        url: `/public/${API_URL.FEEDBACK}/get/${id}`,
        method: "post",
      }),
    }),
    feedbackImport: builder.mutation<any, any>({
      query: (data: any) => {
        return {
          url: `/public/${API_URL.FEEDBACK}/import`,
          method: "post",
          body: data,
        };
      },
    }),
    feedbackUpdate: builder.mutation<any, any>({
      query: ({ id, data }) => {
        return {
          url: `/public/${API_URL.FEEDBACK}/update/${id}`,
          method: "post",
          body: data,
        };
      },
    }),
    feedbackFollowUp: builder.query({
      query: (data: any) => ({
        url: `/${API_URL.FEEDBACK}/details`,
        method: "post",
        body: data,
        refetchWindowFocus: true,
        refetchOnMountOrArgChange: true,
        keepUnusedDataFor: 10,
        staleTime: 0,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useFeedbackListQuery,
  useFeedbackGetQuery,
  useFeedbackUpdateMutation,
  useFeedbackImportMutation,
  useFeedbackFollowUpQuery,
} = feedbackApi;
